import { RequestAction } from '@redux-requests/core';
import { gql } from '@redux-requests/graphql';
import { AccountConstants } from './../constants';

export interface IUserData {
  password: string;
  oldPassword: string;
}

export const saveUserData = ({ oldPassword, password }: IUserData): RequestAction => ({
  type: AccountConstants.SAVE_USER_DATA,
  request: {
    query: gql`
      mutation ($oldPassword: String, $password: String) {
        saveUserData(userData: { oldPassword: $oldPassword, password: $password }) {
          id
        }
      }
    `,
    variables: { oldPassword, password },
  },
  meta: {
    getData: ({ saveUserData }) => saveUserData,
  },
});
